import XLSX from 'xlsx';
import moment from 'moment';

export const toExcelThree = function (data, nombreGrafico) {
    if (data.length) {
        let doc = XLSX.utils.book_new()
        let tableEx = XLSX.utils.json_to_sheet(data)
        let title = ""
        if (nombreGrafico > 30) {
            title = nombreGrafico.slice(0, 29).replace(/[^\w\s]/gi, '')
        } else {
            title = nombreGrafico.replace(/[^\w\s]/gi, '')
        }
        let fecha = new Date()
        let dd = fecha.getDate()
        let mm = fecha.getMonth() + 1
        let yyyy = fecha.getFullYear()
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        fecha = dd + '-' + mm + '-' + yyyy
        XLSX.utils.book_append_sheet(doc, tableEx, title)
        XLSX.writeFile(doc, `${nombreGrafico + '_' + fecha}.xlsx`)
    }
};

export const getDateWithFormat = (date, format = 'DD-MM-YYYY') => {
    return moment(date).format(format)
};

export const formatCurrency = (amount, decimalCount = 0, decimal = ",", thousands = ".") => {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
};

export const thousandSeparator = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
};

export const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (
      let offset = 0;
      offset < byteCharacters.length;
      offset += sliceSize
    ) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const downloadPdf = (blob, name) =>{  
  let fileURL = window.URL.createObjectURL(blob);
  let fileLink = document.createElement("a");

  fileLink.href = fileURL;
  fileLink.setAttribute("download", `${name}.pdf`);
  document.body.appendChild(fileLink);

  fileLink.click();
};
